module.exports = __webpack_public_path__ + "static/media/file-lanscape-slash.70159509.svg";